import React from 'react'

export default function ArrowBullet() {
  return (
    <span class="fa-li">
      <i class="fas fa-angle-right text-primary-light"></i>
    </span>
  )
}
